import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-af46d35c")

_pushScopeId("data-v-af46d35c")
const _hoisted_1 = { class: "p-ml-2" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-12" }
const _hoisted_4 = {
  class: "p-mb-2 p-text-bold",
  style: {"word-break":"break-all"}
}
const _hoisted_5 = { class: "p-col-6" }
const _hoisted_6 = { class: "p-d-flex p-flex-column" }
const _hoisted_7 = { class: "p-text-secondary p-text-bold" }
const _hoisted_8 = { class: "p-col-6" }
const _hoisted_9 = { class: "p-d-flex p-flex-column" }
const _hoisted_10 = { class: "p-text-secondary p-text-bold" }
const _hoisted_11 = { class: "p-col-6" }
const _hoisted_12 = { class: "p-d-flex p-flex-column" }
const _hoisted_13 = { class: "p-text-secondary p-text-bold" }
const _hoisted_14 = { class: "p-col-6" }
const _hoisted_15 = { class: "p-d-flex p-flex-column" }
const _hoisted_16 = { class: "p-text-secondary p-text-bold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.datasourceDetail.name), 1),
        _createVNode(_component_router_link, {
          class: "p-pl-0 datasource-detail",
          to: `/workspace/${_ctx.workspaceId}/datasource/${_ctx.datasourceDetail.id}`,
          target: "_blank"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("datasource.metadata.link.details")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("autots.label.createdby")) + ": ", 1)
          ]),
          _createVNode("div", null, [
            _createVNode("span", null, _toDisplayString(_ctx.getFullname(_ctx.datasourceDetail.createdBy)), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("autots.label.createddate")) + ": ", 1)
          ]),
          _createVNode("div", null, [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$moment(_ctx.datasourceDetail.createdDate).fromNow()), 1)
            ], 512), [
              [_directive_tooltip, 
                _ctx.$moment(_ctx.datasourceDetail.createdDate).format(
                  'YYYY-MM-DD HH:mm:ss'
                )
              ]
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("datasource.metadata.total_files")) + ": ", 1)
          ]),
          _createVNode("div", null, [
            _createVNode("span", null, _toDisplayString(_ctx.totalFiles), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("datasource.metadata.total_size")) + ": ", 1)
          ]),
          _createVNode("div", null, [
            _createVNode("span", null, _toDisplayString(_ctx.$humanFileSize(_ctx.totalSize)), 1)
          ])
        ])
      ])
    ])
  ]))
})